<template>
  <!-- model.approve：是否审批流程中 -->
  <!-- 甲方代表：partyAId 乙方：customerId 售后：afterServiceId 总部：hqId -->
  <!-- 终止设备销售 -->

  <div class="contract-stop-rent">
    <h1 class="item-title">{{ $t('components_contract_stop_sale.he_tong_xin_xi') }}</h1>
    <div class="item-title-info">
      <el-row>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_sale.he_tong_lei_xing') }}:</span>
          <span class="value">{{ getDicValue('crm_contract_type', detail.contractType) }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_sale.he_tong_bian_hao') }}:</span>
          <span class="value">{{ detail.contractNo }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_sale.sghth') }}:</span>
          <span class="value">{{ detail.customContractNo }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_sale.jfsqdbgs') }}:</span>
          <span class="value">{{ detail.partyAName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_sale.yi_fang') }}:</span>
          <span class="value">{{ detail.customerName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_sale.shou_hou_gong_si') }}:</span>
          <span class="value">{{ detail.afterServiceName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_sale.xiang_mu_ming_cheng') }}:</span>
          <span class="value">{{ detail.locationName }}</span>
        </el-col>
        <el-col :span="16">
          <span class="label">{{ $t('components_contract_stop_sale.shi_yong_di_dian') }}:</span>
          <span class="value">{{ detail.country || '' }}{{ detail.province || '' }}{{ detail.city || '' }}{{ detail.useAddress }}</span>
        </el-col>
      </el-row>
    </div>
    <h1 class="item-title">{{ $t('components_contract_stop_sale.sbbgxx') }}</h1>
    <div class="stop-rent-tip" v-if="lastDevice.length">
      <i class="icon icon-tishi"></i>
      <span>{{ $t('components_contract_stop_sale.ji_shen_hao') }}{{ lastDevice.join('，') }}{{ $t('components_contract_stop_sale.yi_xu_zu') }}，{{ $t('components_contract_stop_sale.qxzxzhtohtzzsbzlhzcz', [lastContract.join(',')]) }}</span>
    </div>
    <div style="margin-bottom: 30px">
      <custom-table
        :expand="model.type === 'watch' && model.approve"
        :default-expand-all="model.type === 'watch'"
        ref="customTb1"
        v-model="selectDevice"
        type="checkbox"
        tableCode="contractStopSaleDevice"
        :data="dataList"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['deviceBackTime', 'deviceBackOrgName', 'changeRemark']"
      >
        <!-- 展开内容 -->
        <template slot="expand" slot-scope="scope">
          <div>
            <div class="end-contract-info">
              <el-row>
                <el-col :span="6">
                  <ul>
                    <li v-if="scope.row.factory && detail.hqId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_sale.zong_bu_yi_shou') }}</span>
                      <span class="value">{{ scope.row.factory.receivedRental || '-' }}</span>
                    </li>
                    <li v-if="scope.row.service && detail.afterServiceId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_sale.shgsys') }}</span>
                      <span class="value">{{ scope.row.service.receivedRental || '-' }}</span>
                    </li>
                    <li v-if="scope.row.agent">
                      <span class="label">{{ $t('components_contract_stop_sale.jfdbys') }}</span>
                      <span class="value">{{ scope.row.agent.receivedRental || '-' }}</span>
                    </li>
                  </ul>
                </el-col>
                <el-col :span="6">
                  <ul>
                    <li v-if="scope.row.factory && detail.hqId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_sale.zbkpje') }}</span>
                      <span class="value">{{ scope.row.factory.invoiceAmount || '-' }}</span>
                    </li>
                    <li v-if="scope.row.service && detail.afterServiceId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_sale.shgskpje') }}</span>
                      <span class="value">{{ scope.row.service.invoiceAmount || '-' }}</span>
                    </li>
                    <li v-if="scope.row.agent">
                      <span class="label">{{ $t('components_contract_stop_sale.jfdbkpje') }}</span>
                      <span class="value">{{ scope.row.agent.invoiceAmount || '-' }}</span>
                    </li>
                  </ul>
                </el-col>
                <el-col :span="6">
                  <ul>
                    <li v-if="scope.row.factory && detail.hqId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_sale.zong_bu_ying_shou') }}</span>
                      <!-- <span class="value">{{ scope.row.factory.receivableRental || '-' }}</span> -->
                      <el-input
                        class="red-input"
                        v-if="scope.row.factory.receivableRental !== undefined && scope.row.factory.receivedRental == 0 && scope.row.factory.invoiceAmount == 0"
                        type="number"
                        :disabled="model.showProcess"
                        :min="0"
                        v-model="scope.row.factory.receivableRental"
                        style="width: 60%"
                      ></el-input>
                      <span class="value" v-else>{{ scope.row.factory.receivableRental || '-' }}</span>
                    </li>
                    <li v-if="scope.row.service && detail.afterServiceId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_sale.shgsys') }}</span>
                      <!-- <span class="value">{{ scope.row.service.receivableRental || '-' }}</span> -->
                      <el-input
                        class="red-input"
                        v-if="scope.row.service.receivableRental !== undefined && scope.row.service.receivedRental == 0 && scope.row.service.invoiceAmount == 0"
                        type="number"
                        :disabled="model.showProcess"
                        :min="0"
                        v-model="scope.row.service.receivableRental"
                        style="width: 60%"
                      ></el-input>
                      <span class="value" v-else>{{ scope.row.service.receivableRental || '-' }}</span>
                    </li>
                    <li v-if="scope.row.agent">
                      <span class="label">{{ $t('components_contract_stop_sale.jfdbys') }}</span>
                      <!-- <span class="value">{{ scope.row.agent.receivableRental || '-' }}</span> -->
                      <el-input
                        class="red-input"
                        v-if="scope.row.agent.receivableRental !== undefined && scope.row.agent.receivedRental == 0 && scope.row.agent.invoiceAmount == 0"
                        type="number"
                        :disabled="model.showProcess"
                        :min="0"
                        v-model="scope.row.agent.receivableRental"
                        style="width: 60%"
                      ></el-input>
                      <span class="value" v-else>{{ scope.row.agent.receivableRental || '-' }}</span>
                    </li>
                  </ul>
                </el-col>
                <el-col :span="6">
                  <ul>
                    <li v-if="scope.row.factory && detail.hqId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_sale.zong_bu_ying_tui') }}</span>
                      <el-input
                        class="red-input"
                        v-if="
                          scope.row.factory.refundAmount !== undefined &&
                          scope.row.factory.receivableRental &&
                          scope.row.factory.receivedRental &&
                          scope.row.factory.receivableRental == scope.row.factory.receivedRental
                        "
                        type="number"
                        :disabled="model.showProcess"
                        :min="0"
                        :max="Number.parseInt(scope.row.factory.receivedRental || 0, 10)"
                        v-model.number="scope.row.factory.refundAmount"
                        @input="onChangeMax($event, scope.row.factory, Number.parseInt(scope.row.factory.receivedRental || 0, 10))"
                        style="width: 60%"
                      ></el-input>
                      <span class="value" v-else>{{ scope.row.factory.refundAmount || '-' }}</span>
                    </li>
                    <li v-if="scope.row.service && detail.afterServiceId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_sale.shgsyt') }}</span>
                      <el-input
                        class="red-input"
                        v-if="
                          scope.row.service.refundAmount !== undefined &&
                          scope.row.service.receivableRental &&
                          scope.row.service.receivedRental &&
                          scope.row.service.receivableRental == scope.row.service.receivedRental
                        "
                        type="number"
                        :disabled="model.showProcess"
                        :min="0"
                        :max="Number.parseInt(scope.row.service.receivedRental || 0, 10)"
                        v-model.number="scope.row.service.refundAmount"
                        @input="onChangeMax($event, scope.row.service, Number.parseInt(scope.row.service.receivedRental || 0, 10))"
                        style="width: 60%"
                      ></el-input>
                      <span class="value" v-else>{{ scope.row.service.refundAmount || '-' }}</span>
                    </li>
                    <li v-if="scope.row.agent">
                      <span class="label">{{ $t('components_contract_stop_sale.jfdbyt') }}</span>
                      <el-input
                        class="red-input"
                        v-if="
                          scope.row.agent.refundAmount !== undefined &&
                          scope.row.agent.receivableRental &&
                          scope.row.agent.receivedRental &&
                          scope.row.agent.receivableRental == scope.row.agent.receivedRental
                        "
                        type="number"
                        :disabled="model.showProcess"
                        :min="0"
                        :max="Number.parseInt(scope.row.agent.receivedRental || 0, 10)"
                        v-model.number="scope.row.agent.refundAmount"
                        @input="onChangeMax($event, scope.row.agent, Number.parseInt(scope.row.agent.receivedRental || 0, 10))"
                        style="width: 60%"
                      ></el-input>
                      <span class="value" v-else>{{ scope.row.agent.refundAmount || '-' }}</span>
                    </li>
                  </ul>
                </el-col>
              </el-row>
            </div>
          </div>
        </template>
        <!-- 设备退回日期 -->
        <template slot="deviceBackTime" slot-scope="scope">
          <custom-date-picker
            :disabled="!model.showProcess && model.approve ? false : model.type === 'watch' || scope.row.isExists"
            style="width: 100%"
            v-model="scope.row.saleBackTime"
            align="right"
            type="datetime"
            :default-value="
              scope.row.currentTermStartTime &&
              scope.row.nextTermEndTime &&
              ($moment().isBefore(new Date(`${scope.row.currentTermStartTime}Z`).getTime(), 'day') || $moment().isAfter(new Date(`${scope.row.nextTermEndTime}Z`).getTime(), 'day'))
                ? new Date(`${scope.row.currentTermStartTime}Z`)
                : undefined
            "
            value-format="YYYY-MM-DD HH:mm:ss"
            :default-time="$moment().format('HH:mm:ss')"
            :picker-options="{
              disabledDate(time) {
                return scope.row.currentTermStartTime && scope.row.nextTermEndTime
                  ? $moment(time).isBefore(new Date(`${scope.row.currentTermStartTime}Z`).getTime(), 'day') || $moment(time).isAfter(new Date(`${scope.row.nextTermEndTime}Z`).getTime(), 'day')
                  : !($moment(time).subtract(7, 'd').isBefore(new Date().getTime(), 'day') && $moment(time).add(7, 'd').isAfter(new Date().getTime(), 'day'));
              },
            }"
          ></custom-date-picker>
        </template>
        <!-- 退回地点 -->
        <template slot="deviceBackOrgName" slot-scope="scope">
          <custom-select
            width="100%"
            :data="orgList"
            :auto="scope.$index === 0"
            :disabled="model.type === 'watch' || scope.row.isExists"
            v-model="scope.row.deviceBackOrgId"
            url="ChangeOrderSaleSelectAd"
            :params="{ orderDeviceId: scope.row.orderDeviceId, isShowHq: true }"
            :props="{ label: 'partnerName', value: 'partnerOrgId' }"
            @change="onSelectBackOrg($event, scope.row)"
            @getList="getList"
          ></custom-select>
        </template>
        <!-- 设备退回原因 -->
        <template slot="changeRemark" slot-scope="scope">
          <custom-auto
            :disabled="model.type === 'watch' || scope.row.isExists"
            :placeholder="$t('components_contract_stop_sale.mo_ren_tong_shang')"
            v-model="scope.row.changeRemark"
            width="100%"
            value-key="name"
            code="stop_order_sale_remark"
          ></custom-auto>
        </template>
      </custom-table>
    </div>
    <el-form :model="form" :inline="true" :rules="rules" ref="form" label-width="86px">
      <el-form-item :label="$t('components_contract_stop_sale.shen_qing_miao_shu')" prop="changeDesc">
        <el-input type="textarea" :rows="4" :disabled="model.type === 'watch'" :placeholder="$t('components_contract_stop_sale.qstxsqsm')" v-model="form.changeDesc" style="width: 626px"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import customAuto from '@/components/customAuto';
import moment from 'moment';

export default {
  components: { customAuto },
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch
          changeId: '', // 新增时为orderId, 编辑查看时为changeId
          approve: false, // 是否是审批页
          approveCurrentNo: '', // 当前审批在哪一步
        };
      },
    },
  },
  data() {
    return {
      orgList: [],
      dataList: [],
      selectDevice: [],
      lastDevice: [],
      lastContract: [],
      disableReturnDevice: [],
      detail: {},
      form: {
        changeOrderId: '',
        orderId: '',
        changeDesc: '',
        changeOrderDevices: [],
      },
    };
  },
  computed: {
    rules() {
      return {
        changeDesc: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
        ],
      };
    },
    // 是否总部
    isHq() {
      const userInfo = this.$store.state.userInfo || {};
      return userInfo.bizType === 'HQ';
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    onChangeMax: function (value, model, max) {
      if (value > max) {
        this.$set(model, 'refundAmount', max);
      }
    },
    // 处理数据
    formatBillList: function (to, form) {
      // 自定义字段
      const billList = form.billList || [];
      const factory = billList.find(t => t.receivableOrgType === 'HQ') || {}; // 总部
      const service = billList.find(t => t.receivableOrgType === 'SC') || {}; // 售后公司
      let agent = billList.find(t => t.receivableOrgType === 'JV' || t.receivableOrgType === 'JV_SC') || {}; // 甲方代理
      // 甲方代表和总部一致， 保留甲方代表（数据取总部的）
      if (this.detail.partyAId === this.detail.hqId) {
        agent = factory;
      }
      // 保证input绑定有字段
      factory.refundAmount = factory.refundAmount === undefined ? 0 : factory.refundAmount;
      service.refundAmount = service.refundAmount === undefined ? 0 : service.refundAmount;
      agent.refundAmount = agent.refundAmount === undefined ? 0 : agent.refundAmount;
      factory.receivableRental = factory.receivableRental === undefined ? 0 : factory.receivableRental;
      service.receivableRental = service.receivableRental === undefined ? 0 : service.receivableRental;
      agent.receivableRental = agent.receivableRental === undefined ? 0 : agent.receivableRental;

      this.$set(to, 'factory', factory);
      this.$set(to, 'service', service);
      this.$set(to, 'agent', agent);
      this.$set(to, 'billList', billList);
    },
    // 获取设备账单
    getChangeBill: function (row) {
      this.formatBillList(row, {});
      this.$getJSON(apis.ChangeOrderSaleBill, {
        orderDeviceIds: row.orderDeviceId,
      }).then((res) => {
        const result = res.data || [{}];
        this.formatBillList(row, result[0]);
      });
    },
    // 组织下拉
    getList: function (list) {
      this.orgList = list;
    },
    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        this.form.orderId = this.model.changeId;
        this.getOrderInfo(() => {
          this.getDeviceList();
        });
      }
      if (this.model.type === 'edit') {
        this.form.changeOrderId = this.model.changeId;
        this.getChangeDetail((list) => {
          this.getDeviceList(list);
        });
      }
      if (this.model.type === 'watch') {
        this.form.changeOrderId = this.model.changeId;
        this.getChangeDetail((list) => {
          this.dataList = list;
          this.dataList.forEach((item) => {
            item.isExists = true;
            if (this.model.approve) {
              if (this.model.showProcess) {
                this.formatBillList(item, item);
              } else {
                this.getChangeBill(item);
              }
            }
            this.$refs.customTb1.$emit('toggleRowSelection', item, true);
          });
        });
      }
    },

    // 订单信息
    getOrderInfo: function (cb) {
      cb = cb || function () {};
      this.$getJSON(apis.saleOrderInfo, {
        bizId: this.model.changeId,
      }).then((res) => {
        this.detail = res.data;
        cb();
      });
    },
    // 获取变更详情
    getChangeDetail: function (cb) {
      cb = cb || function () {};
      this.$getJSON(apis.ChangeOrderSaleInfo, {
        changeOrderId: this.model.changeId,
      }).then((res) => {
        this.detail = res.data;
        this.form.orderId = res.data.orderId;
        this.form.changeDesc = res.data.changeDesc;
        cb(res.data.changeDeviceInfos);
      });
    },
    // 合同设备列表
    getDeviceList: function (selectDevice) {
      this.$getJSON(apis.ChangeOrderSaleDevice, {
        orderId: this.form.orderId,
        orderType: this.model.row.contractClass,
        bizState: ['10', '50', '52'],
      }).then((res) => {
        const list = res.data;
        list.forEach((item) => {
          item.saleBackTime = selectDevice ? '' : this.$momentWorld(moment().format('YYYY-MM-DD HH:mm:ss')); // 默认有值，需要确认是否置空
          item.deviceBackOrgId = selectDevice ? '' : item.afterServiceId;
          item.deviceBackOrgName = selectDevice ? '' : item.afterServiceName;
          this.formatBillList(item, {});
        });
        this.dataList = list;
        // 编辑状态时
        if (selectDevice) {
          this.dataList.forEach((item) => {
            const row = selectDevice.find(t => t.orderDeviceId === item.orderDeviceId);
            if (row) {
              item.saleBackTime = row.saleBackTime;
              item.deviceBackOrgId = row.deviceBackOrgId;
              item.deviceBackOrgName = row.deviceBackOrgName;
              item.changeRemark = row.changeRemark;
              this.formatBillList(item, row);
              this.$refs.customTb1.$emit('toggleRowSelection', item, true);
            }
          });
        }
      });
    },
    // 选择退回地址
    onSelectBackOrg: function (data, row) {
      row.deviceBackOrgName = data.partnerName;
    },

    // 确认保存
    onConfirm: function (approve) {
      if (this.model.type === 'watch') {
        this.$emit('close');
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (!this.selectDevice.length) {
          this.$message.error(this.$t('components_contract_stop_sale.qing_xuan_ze_she_bei'));
          return;
        }
        const hasEmpty = this.selectDevice.filter(f => !this.disableReturnDevice.includes(f.bodyNum)).find(t => t.bodyNum && (!t.deviceBackOrgId || !t.saleBackTime));
        if (hasEmpty) {
          this.$message.error(this.$t('components_contract_stop_sale.qxzjqthrqhsbthdz'));
          return;
        }
        const hasFirstEmpty = !this.selectDevice[0]['changeRemark'];
        if (hasFirstEmpty) {
          this.$message.error(this.$t('components_contract_stop_sale.qtxsbthyy'));
          return;
        }
        this.form.isStartApprove = approve || 0;
        this.form.changeOrderDevices = this.$formatCopyUp(this.selectDevice, ['changeRemark']);
        this.$postJSON(apis.ChangeStopSaleSave, this.form).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success');
        });
      });
    },
  },
};
</script>

<style lang="scss">
.contract-stop-rent {
  .red-input input {
    color: red;
    font-weight: bold;
  }
  .stop-rent-tip {
    background: rgba(254, 244, 219, 1);
    margin-bottom: 16px;
    padding-left: 10px;
    .icon {
      color: #eebf4d;
      font-size: 12px;
      margin-right: 10px;
    }
    span {
      line-height: 32px;
      color: #6c757d;
      font-size: 12px;
    }
  }
}
</style>
